import { c as _c } from "react/compiler-runtime";
import { cx } from "@/lib/tailwind-utils";
type PresenceStatus = "ONLINE" | "WITH_CLIENT" | "BUSY" | "OFFLINE";
const dotColorMap: Record<Exclude<PresenceStatus, "OFFLINE">, string> = {
  ONLINE: "bg-status-success-text",
  WITH_CLIENT: "bg-status-warning-text",
  BUSY: "bg-status-error-text"
};
interface PresenceIndicatorProps {
  status: PresenceStatus | undefined;
  size?: number;
  children: React.ReactNode;
}
export function PresenceIndicator(t0) {
  const $ = _c(12);
  const {
    status,
    size: t1,
    children
  } = t0;
  const size = t1 === undefined ? 36 : t1;
  const showDot = !!status && status !== "OFFLINE";
  const dotSize = size <= 24 ? 8 : size <= 32 ? 10 : 12;
  const borderWidth = size <= 24 ? 1.5 : 2;
  let t2;
  if ($[0] !== dotSize || $[1] !== size) {
    t2 = Math.round(size * 0.146 - dotSize / 2);
    $[0] = dotSize;
    $[1] = size;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const edgeOffset = t2;
  let t3;
  if ($[3] !== borderWidth || $[4] !== dotSize || $[5] !== edgeOffset || $[6] !== showDot || $[7] !== status) {
    t3 = showDot && <span className={cx("absolute rounded-full border-solid border-background", dotColorMap[status])} style={{
      width: `${dotSize}px`,
      height: `${dotSize}px`,
      borderWidth: `${borderWidth}px`,
      bottom: `${edgeOffset}px`,
      right: `${edgeOffset}px`
    }} />;
    $[3] = borderWidth;
    $[4] = dotSize;
    $[5] = edgeOffset;
    $[6] = showDot;
    $[7] = status;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== children || $[10] !== t3) {
    t4 = <div className="shrink-0 leading-[0]">{children}{t3}</div>;
    $[9] = children;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}